import Vue from 'vue';

export default class AppBase extends Vue {
    get isMobile() {
        return this.$store.state.isMobile;
    }

    get isLoading() {
        return this.$store.state.isLoading;
    }

    get isAuthenticated() {
        return this.$store.state.isAuthenticated;
    }

    get user() {
        return this.$store.state.loggedUser;
    }

    get lang() {
        return this.$store.state.lang;
    }

    get isPopup() {
        return this.$route.query.popup;
    }

    // Utilities

    link(name: string, params?: any) {
        return { name, params };
    }

    setLoading(isLoading = true) {
        this.$store.commit('setLoading', isLoading);
    }

    getText(texts: any, key: string) {
        let lang = this.lang;
        if (lang && texts && texts[lang]) {
            return texts[lang][key];
        }
        return "";
    }

}


// WEBPACK FOOTER //
// ./src/app/common/base.ts